import CreateAxiosInstance from './axiosConfig';
const APIClient = CreateAxiosInstance(import.meta.env.VITE_API_BASE_URL);

export async function getQuoteFromOpportunity({ opportunityId }) {
  return await APIClient.get(`/pricing`, {
    params: {
      opportunityId,
    },
  });
}

export async function addNewSchool({
  schoolName,
  city,
  state,
  country,
  enrollment,
  addSchoolToSalesforce,
}) {
  return await APIClient.post(`/pricing/add_school`, {
    school_name: schoolName,
    city,
    state,
    country,
    enrollment,
    add_school_to_salesforce: addSchoolToSalesforce,
  });
}

export async function createQuote({ opportunity }) {
  return await APIClient.post(`/pricing/request_school_quote`, opportunity);
}

export async function createDistrictQuote({ opportunity }) {
  return await APIClient.post(`/pricing/request_district_quote`, opportunity);
}

export async function submitOrder(data) {
  const formData = new FormData();
  for (const key in data) {
    formData.append(key, data[key]);
  }

  return await APIClient.post(`/pricing/submit_school_order`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}
